import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Button } from '@material-ui/core';
import moment from 'moment'

class AddLessonsToCourseDialog extends Component {

    render() {
        const { classes, event } = this.props

        return (
            <Dialog
                open={this.props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.props.closeDialogState(false, {}, true)}
            >
                <DialogTitle>Delete lesson or entire component?</DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <p>Lesson: {event.title}</p>
                            <p>Date: {moment(event.start).format('MM/DD/YYYY')}</p>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState(false, event)}
                            >Delete Lesson
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState(true, event)}
                            >Delete Full Component
                            </Button>
                        </Grid>
                    </Grid>

                </DialogContent>
            </Dialog>
        )
    }
}

export default AddLessonsToCourseDialog;


// WEBPACK FOOTER //
// src/main/content/company/CompanyCalendar/DeleteItemDialog.js